// TODO: Adjust routing paths for LNG
import { LAYOUT_ENTITIES, LAYOUT_FRONTSPACES } from '@bedrock/fido-sdk';
import _get from 'lodash/get';
import { FRONTSPACE } from '@bedrock-rdk/constants';
import { ProfilesGate } from '../profilesGate/profilesGate.component';
import { AbstractLayout } from '../layout/abstractLayout.component';
import { Search } from '../search/search.component';
import { ExploreCatalogue } from '../exploreCatalogue/exploreCatalogue.component';

export const isEPG = (entityType, entityId) => entityType === FRONTSPACE && entityId === LAYOUT_FRONTSPACES.epggrid;

export const isSearch = (entityType, entityId) => entityType === FRONTSPACE && entityId === LAYOUT_FRONTSPACES.search;

export const isProfilesGate = (entityType, entityId) =>
  entityType === LAYOUT_ENTITIES.frontspace && entityId === LAYOUT_FRONTSPACES.profilesgate;

export const isExploreCatalogue = (entityType, entityId, areBlocksEmpty) =>
  entityType === FRONTSPACE && entityId === LAYOUT_FRONTSPACES.bookmarks && areBlocksEmpty;

export const getRenderer = layout => {
  const { type: entityType, id: entityId } = layout.entity || {};
  const areBlocksEmpty = !_get(layout, 'blocks.length');

  if (isProfilesGate(entityType, entityId)) {
    return ProfilesGate;
  }

  if (isSearch(entityType, entityId)) {
    return Search;
  }

  if (isExploreCatalogue(entityType, entityId, areBlocksEmpty)) {
    return ExploreCatalogue;
  }

  return AbstractLayout;
};
